import Button from '../../shared/button/Button';
import styles from './TelegramSubscription.module.scss';
import TelegramIcon from '../../../../assets/images/socialIcon/Telegram.svg';
import CloseIcon from '../../../../assets/images/icons/cross.svg';
import { useLayoutEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

const TELEGRAM_CHANNEL_URL = 'https://t.me/+Y0F_o4vuo3YxYWQy';
const TELEGRAM_WIDGET_STORAGE_KEY = 'telegramWidgetVisibility';

const TelegramSubscriptionWidget = () => {
  const [isVisible, setIsVisible] = useState<boolean>(false);

  const { t } = useTranslation(['common']);

  useLayoutEffect(() => {
    const visibilityStorageValue = localStorage.getItem(
      TELEGRAM_WIDGET_STORAGE_KEY,
    );
    const isVisible =
      typeof visibilityStorageValue === 'string'
        ? visibilityStorageValue === 'true'
        : true;

    setIsVisible(isVisible);
  }, []);

  const onOpenChannel = () => {
    window.open(TELEGRAM_CHANNEL_URL, '_blank');

    onHideWidget();
  };

  const onHideWidget = () => {
    localStorage.setItem(TELEGRAM_WIDGET_STORAGE_KEY, 'false');

    setIsVisible(false);
  };

  return isVisible ? (
    <div className={styles.telegramSubscriptionContainer}>
      <img
        src={CloseIcon}
        alt='close'
        role='button'
        className={styles.telegramSubscriptionContainer__close}
        onClick={onHideWidget}
      />
      <img
        src={TelegramIcon}
        alt='telegram'
        className={styles.telegramSubscriptionContainer__icon}
      />
      <div>{t('widget.telegram.text')}</div>
      <Button
        onClick={onOpenChannel}
        className={styles.telegramSubscriptionContainer__button}
      >
        {t('widget.telegram.button')}
      </Button>
    </div>
  ) : null;
};

export default TelegramSubscriptionWidget;
